// extracted by mini-css-extract-plugin
export default {"tabs":"ProjectSheetTabBar_tabs__rLPl6","tab":"ProjectSheetTabBar_tab__jar-U","active":"ProjectSheetTabBar_active__chOmi"};